<template>
    <div class="y-buttons flex items-center">
        <template v-for="(button, index) in buttons">
            <slot :name="button.key" :button="button">
                <div class="flex items-center" :key="button.key">
                    <span class="cursor-pointer" :class="button.className || ''"
                        @click="triggerEvent(button.events.click)">{{
            button.label }}</span>
                    <i v-if="index !== (buttons.length - 1)" class="not-italic mx-3">|</i>
                </div>
            </slot>
        </template>
    </div>
</template>

<script>
export default {
    name: 'y-buttons',
    props: {
        buttons: {
            type: Array,
            default() {
                return [] //{key:'delete',className:'',label:'',events:{click}}
            }
        },
        record: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {}
    },
    computed: {
        buttonsWithSlot({ buttons }) {
            return buttons.filter(({ slot }) => {
                return slot
            })
        }
    },
    methods: {
        triggerEvent(handler) {
            handler(this.record)
        }
    }
}
</script>